module.exports = __webpack_public_path__ + "static/media/covid_qr_p1_1.3aa573e7.png";